<public>

  <div id="swinging-in-caves">
      <div id="swinging-in-caves-form-wrapper" fxLayout="column" fxLayoutAlign="start start" fxFlex="100">
          <div id="swinging-in-caves-form">
              <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start start">

                  <div fxLayout="column" fxFlex="100">
                    <div>

                      <div style="padding: 12px;" class="jumbotron text-center" fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column">
                        <div fxFlex="20" fxLayout="column">
                          <h1 class="subHeader" style="line-height: 60px;">
                            Swingin' In Caves
                          </h1>
                          <div class="image_icon" style="padding: 12px;">
                            <img style="width: 200px; height: 200px; margin-bottom: 24px;" src="assets/images/avatar-512-blue.png">
                          </div>
                        </div>
                        <div fxFlex="80" fxLayout="column">
                          <h1>Overview</h1>
                          <em class="box-copter-hero-text" style="display: inline-block !important; color: #fff; font-size: 24px; line-height: 76px !important; font-family: 'Raleway', sans-serif;">
                            <img style="width: 50px; height: 50px;" src="assets/images/large-quote-start.png" />
                            Use a grappling hook to swing through an endless series of caves.
                            <img style="width: 50px; height: 50px;" src="assets/images/large-quote-end.png" />
                          </em>
                          <mat-divider style="border-top-width: 1px; border-top-color: #fff;"></mat-divider>
                          <h1>
                            External Links
                          </h1>
                          <a (click)="navigate('https://www.behance.net/gallery/110004715/Swingin-In-Caves')" style="padding: 6px;"><img src="assets/images/icons/behance.png" style="width: 32px; height: 32px;" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</public>
